document.addEventListener('DOMContentLoaded', function() {
  // Get your store's domain
  var currentDomain = window.location.hostname;
  
  // Get all links on the page
  var links = document.querySelectorAll('a[href]');
  
  links.forEach(function(link) {
    var href = link.getAttribute('href');

    if (href === null) {
      return;
    }
    
    // Skip if it already has a target set or is a relative link
    if (link.hasAttribute('target') || href.startsWith('#') || href.startsWith('/')) {
      return;
    }
    
    // Check if it's an external link
    try {
      var linkUrl = new URL(href, window.location.href);
      if (linkUrl.hostname !== currentDomain) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {
      // Invalid URL, skip it
    }
  });
});